// extracted by mini-css-extract-plugin
export default {"dashGrid":"DashboardLayout_dashGrid__FBq3i","dashContent":"DashboardLayout_dashContent__9clzJ","mobileModeToggle":"DashboardLayout_mobileModeToggle__I+k2W"};